import {ACCESS_TOKEN} from "../constants/auth";
import {API_BASE_URL} from "../constants/api";
import axios from "axios";
import CategoryService from "./CategoryService";
import DocumentService from "./DocumentService";
import FileUploaderService from "./FileUploaderService";

const CertificateService = {};

CertificateService.getOldCertificateByCode = async function (code) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/old-certificate/get/${code}`,
        headers: {
            "Content-Type": "application/json"
        }
    });
}

CertificateService.getCertificateByCode = async function (code) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/certificate/get-code/${code}`,
        headers: {
            "Content-Type": "application/json"
        }
    });
}

CertificateService.countUnsignedCertificates = async function () {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/certificate/rector/count`,
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

CertificateService.getCertificatesByIIN = async function (iin) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/certificate/get-iin/${iin}`,
        headers: {
            "Content-Type": "application/json"
        }
    });
}

CertificateService.getCertificateById = async function (id) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/certificate/get-code/${id}`,
        headers: {
            "Content-Type": "application/json"
        }
    });
}

CertificateService.getAllCertificates = async function (page, limit, username, issueDate, signed, categoryId) {
    const params = {
        page: page - 1,
        limit: limit
    };

    if (username) {
        params.name = username;
    }
    if (issueDate) {
        params.date = issueDate;
    }
    if (signed !== undefined && signed != null) {
        params.signed = signed;
    }
    if (categoryId !== undefined) {
        params.categoryId = categoryId;
    }

    const response = await axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/certificate/get`,
        params,
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    const data = response.data.list;
    const hasMore = response.data.hasMore;
    return {data, hasMore};
}

CertificateService.getAllCertificateTemplates = async function (page, limit) {
    const response = await axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/certificate-template/get`,
        params: {
            page: page - 1,
            limit: limit
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    const data = response.data.list;
    const hasMore = response.data.hasMore;
    return {data, hasMore};
}

CertificateService.getResourceById = async function (id) {
    return axios({
        method: "get",
        url: API_BASE_URL + "/api/certificate/resource/code/" + id,
        responseType: "blob"
    });
}

CertificateService.getResourceByCertificateId = async function (id) {
    return axios({
        method: "get",
        url: API_BASE_URL + "/api/certificate/resource/" + id,
        responseType: "blob"
    });
}

CertificateService.convertExcelToCertificates = async function (file, id) {
    let data = new FormData();
    data.append("file", file);
    data.append("certTemplateId", id);

    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/certificate/import`,
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

CertificateService.getExcelByTemplateId = async function (id) {
    return axios({
        method: "get",
        url: API_BASE_URL + "/api/admin/certificate/download/template-excel",
        params: {
            certTemplateId: id,
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        },
        responseType: "blob"
    });
}

CertificateService.saveCertificateManual = async function (templateId, studentId, code, fields) {
    const data = {
        templateId,
        fields,
        code
    };

    if (studentId) {
        data.studentId = studentId;
    }
    return axios({
        method: "post",
        url: API_BASE_URL + "/api/admin/certificate/save-manual",
        data,
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

CertificateService.saveCertificateGroup = async function (templateId, groupId) {
    let data = new FormData();
    data.append("templateId", templateId);
    data.append("groupId", groupId);
    return axios({
        method: "post",
        url: API_BASE_URL + "/api/admin/certificate/save/by-group",
        params: {
            templateId: templateId,
            groupId: groupId
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}


CertificateService.saveCertificateTemplate = async function (name, template, hashMap) {
    return axios({
        method: "post",
        url: API_BASE_URL + "/api/admin/certificate-template/save",
        data: {
            name: name,
            template: template,
            codeNames: hashMap
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
};

CertificateService.editCertificateTemplate = async function (id, name, template, hashMap) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/certificate-template/edit/${id}`,
        data: {
            name: name,
            template: template,
            codeNames: hashMap
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
};

CertificateService.deleteCertificateTemplate = async function (id) {
    return axios({
        method: "delete",
        url: API_BASE_URL + `/api/admin/certificate-template/delete/${id}`,
        headers: {
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

export default CertificateService;